import router from '@/router'
import { getCurrentUser } from '@/plugins/stitch'
import Users from '@/models/Users'

const FIRST_LOAD_ACTIONS = [
  'waitForLogin',
  'user/bindCurrentUser',
  // 'user/bindIntegrations', // TODO: migrate to stitch
  // 'user/bindEngagement', // TODO: migrate to stitch
  'organizations/bindCurrentOrganization',
  'organizations/loadCustomFields',
  'loadAllUsers'
  // 'projects/bind'
]

// convenience variable to pass args between async.each
let lastReturn = null

export default {
  async loadAllUsers ({ commit, rootGetters }) {
    const org = rootGetters['organizations/currentOrganization']
    if (!org) { return }

    const users = new Users()
    await users.fetch({
      user: { $in: org.users }
    })

    commit('atlas/syncModel', {
      path: 'users',
      value: users.models.map(u => u.$)
    })
  },
  async waitForLogin ({ commit }) {
    const loggedUser = getCurrentUser()
    // let user = null
    let ret = null

    if (loggedUser) {
      // merge stitch account user and user in mongo db
      // user = await db
      //   .collection('users')
      //   .findOne({ user: loggedUser.id })
      // user.id = loggedUser.id

      // user.currentOrganization = await db
      //   .collection('organizations')
      //   .findOne({ _id: user.currentOrganization })
      // user.currentOrganization.id = user.currentOrganization._id.toString()

      // user.email = loggedUser.profile.email

      lastReturn = loggedUser.id
      if (router.currentRoute.name === 'login') {
        router.push({
          path: router.currentRoute.query.redirect || '/'
        })
      }
    } else {
      // Not logged in, stop the init process
      ret = { stop: true }
    }

    // commit('user/setCurrentUser', user)
    return ret
  },
  doFirstLoad ({ commit, dispatch }, { reload } = { reload: false }) {
    commit('setAppLoading', true)

    return new Promise(async (resolve, reject) => {
      for (let i in FIRST_LOAD_ACTIONS) {
        const action = FIRST_LOAD_ACTIONS[i]

        try {
          const resolved = await dispatch(action, lastReturn)

          // If dispatch() promise resolve with a truthy arg, then stop
          // ex.: this is used if not logged-in to stop the init without reject()
          if (resolved && resolved.stop) { break }
        } catch (err) {
          throw new Error(`First Load ${action}: err`)
        }
      }

      commit('setAppLoading', false)
      resolve()
    })
  }
}
